"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { useList } from '../../../../hooks/useList.mjs';
import styles from './ActiveFilters.module.scss.mjs';
import locales from '../../../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';
import { Translate } from '../../../../../../lib/react/components/Translate/Translate.mjs';
import { observer } from 'mobx-react-lite';
import { useLocalizedStringFormatter } from 'react-aria';
import { TooltipTrigger } from '../../../../../Tooltip/components/TooltipTrigger/TooltipTrigger.mjs';
import 'react-aria-components';
import 'clsx';
import '@tabler/icons-react';
import '../../../../../Icon/Icon.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconClose } from '../../../../../Icon/components/icons/IconClose.mjs';
import { IconSave } from '../../../../../Icon/components/icons/IconSave.mjs';
import { IconUndo } from '../../../../../Icon/components/icons/IconUndo.mjs';
import ButtonView from '../../../../../../views/ButtonView.mjs';
import TooltipView from '../../../../../../views/TooltipView.mjs';
import DivView from '../../../../../../views/DivView.mjs';
import BadgeView from '../../../../../../views/BadgeView.mjs';
import TooltipTriggerView from '../../../../../../views/TooltipTriggerView.mjs';
import TextView from '../../../../../../views/TextView.mjs';

const ActiveFilters = observer(() => {
  const list = useList();
  const formatter = useLocalizedStringFormatter(locales);
  const activeFilterValues = list.filters.flatMap((f) => f.values).filter((v) => v.isActive);
  const activeFilters = activeFilterValues.map((v) => /* @__PURE__ */ jsx(BadgeView, { onClose: () => v.deactivate(), children: /* @__PURE__ */ jsx(TextView, { children: v.render() }) }, v.id));
  const someFiltersChanged = list.filters.filter((f) => f.hasChanged()).length > 0;
  const storeFiltersButton = list.supportsSettingsStorage && someFiltersChanged && /* @__PURE__ */ jsxs(TooltipTriggerView, { children: [
    /* @__PURE__ */ jsx(TooltipView, { children: /* @__PURE__ */ jsx(Translate, { locales, children: "list.filters.store" }) }),
    /* @__PURE__ */ jsx(
      ButtonView,
      {
        size: "s",
        variant: "plain",
        color: "secondary",
        onPress: () => list.storeFilterDefaultSettings(),
        "aria-label": formatter.format("list.filters.store"),
        children: /* @__PURE__ */ jsx(IconSave, {})
      }
    )
  ] });
  const resetFiltersButton = someFiltersChanged ? /* @__PURE__ */ jsxs(TooltipTrigger, { children: [
    /* @__PURE__ */ jsx(TooltipView, { children: /* @__PURE__ */ jsx(Translate, { locales, children: "list.filters.reset" }) }),
    /* @__PURE__ */ jsx(
      ButtonView,
      {
        size: "s",
        variant: "plain",
        color: "secondary",
        onPress: () => list.resetFilters(),
        "aria-label": formatter.format("list.filters.reset"),
        children: /* @__PURE__ */ jsx(IconUndo, {})
      }
    )
  ] }) : void 0;
  const removeAllFiltersButton = activeFilters.length > 0 ? /* @__PURE__ */ jsxs(TooltipTrigger, { children: [
    /* @__PURE__ */ jsx(TooltipView, { children: /* @__PURE__ */ jsx(Translate, { locales, children: "list.filters.clear" }) }),
    /* @__PURE__ */ jsx(
      ButtonView,
      {
        size: "s",
        variant: "plain",
        color: "secondary",
        onPress: () => list.clearFilters(),
        children: /* @__PURE__ */ jsx(IconClose, {})
      }
    )
  ] }) : void 0;
  if (activeFilters.length === 0 && !storeFiltersButton && !resetFiltersButton) {
    return null;
  }
  return /* @__PURE__ */ jsxs(DivView, { className: styles.activeFilters, children: [
    activeFilters,
    storeFiltersButton,
    resetFiltersButton,
    removeAllFiltersButton
  ] });
});

export { ActiveFilters, ActiveFilters as default };
//# sourceMappingURL=ActiveFilters.mjs.map
